import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import AdminLayout from '../../layouts/AdminLayout';
import HadithFormModal from './HadithFormModal';

export default function HadithFormPage() {
  const history = useHistory();
  const { id } = useParams();

  const handleClose = () => {
    history.push('/hadith');
  };

  const handleSuccess = () => {
    history.push('/hadith');
  };

  return (
    <AdminLayout title={id ? 'Edit Hadith' : 'New Hadith'}>
      <HadithFormModal
        open={true}
        hadithId={id || null}
        onClose={handleClose}
        onSuccess={handleSuccess}
      />
    </AdminLayout>
  );
}
